<div class="host ___dashboard page" *ngIf="page$ | async as page; else loadingView">

  <div class="main" *ngIf="page.ok; else notFound;">
  <ng-container *ngIf="data$ | async as data">
  <ng-container *ngIf="!query ? data.groupItems : (data.searchItems || data.groupItems); let activeItems;">

    <div class="head">

      <div class="title">
        <h1>All {{ part.menuItem.text || 'Items' }}</h1>
        <ng-container *ngIf="part.name !== 'profile'">
          <a
            class="button-outline-primary"
            [usefulRouterLink]="['app-dashboard', 'new', part.name]"
            [usefulRouteExtras]="{queryParams: { type: type }}"
          >Add New</a>
        </ng-container>
      </div>

      <ul class="statuses">
        <li *ngFor="let listingStatus of data.listingStatuses">
          <strong *ngIf="listingStatus.value === status; else inactiveStatus;">{{ listingStatus.title }}</strong>
          <ng-template #inactiveStatus>
            <a href="#" (click)="changeStatus(listingStatus.value); false;">{{ listingStatus.title }}</a>
          </ng-template>
          <em>({{ listingStatus.count }})</em>
        </li>
      </ul>

    </div>
    
    <div class="body">

      <ng-template #listingBar>
        <div class="search">
          <input
            class="form-control"
            type="search"
            placeholder="ID or search query ..."
            [(ngModel)]="query"
            (keyup.enter)="search(data.searchQuery)"
          >
          <button class="button-primary" (click)="search(data.searchQuery)" [disabled]="!query">Search</button>
        </div>
        <div class="counter">{{ activeItems.length }} items</div>
      </ng-template>

      <div class="headbar">
        <ng-container *ngTemplateOutlet="listingBar"></ng-container>
      </div>

      <ul class="type-filter" *ngIf="part.contentTypes && part.contentTypes.length > 1">
        <li *ngFor="let contentType of part.contentTypes" [class.active]="type===contentType.value">
          <a
            href="javascript:void(0)"
            (click)="changeType(contentType.value)"
          >
            <i *ngIf="contentType.icon" class="icon-medium-tint" [class]="contentType.icon"></i>
            <span>{{ contentType.text }}</span>
          </a>
        </li>
      </ul>

      <table class="listing table-striped">
        <thead>
          <tr>
            <th class="title">Title</th>
            <th class="author">Author</th>
            <th class="comment"><i class="icon-dark icon-dashboard-comment"></i></th>
            <th class="date">Date</th>
          </tr>
        </thead>  
        <tbody>
          <tr *ngIf="isListingLoading">
            <td colspan="42">
              <div class="loading">
                <nguix-dashboard-spinner></nguix-dashboard-spinner>
              </div>
            </td>
          </tr>
          <tr *ngIf="query && data.searchItems">
            <td colspan="42">Currently view top search result for query "<strong>{{ data.searchQuery }}</strong>", <a href="#" (click)="query=''; false;">clear search</a>.</td>
          </tr>
          <tr *ngIf="!activeItems.length">
            <td colspan="42">No items found!</td>
          </tr>
          <tr *ngFor="let listingItem of activeItems">
          <ng-container
            *ngIf="
              part.noI18n || !data.fullItemsByOrigin[listingItem.id]
                ? [listingItem]
                : data.fullItemsByOrigin[listingItem.id].all;
              let items;
            "
          >
  
            <td class="title">
              <ul>
                <li *ngFor="let item of items">

                  <div class="locale" *ngIf="item.locale">{{ allLocales[item.locale].text }}</div>

                  <div class="major">
                    <span class="label" [class]="item.status" *ngIf="item.status!=='publish'">{{ item.status }}</span>
                    <!-- draft / publish -->
                    <ng-container *ngIf="item.status==='draft' || item.status==='publish'">
                      <a [usefulRouterLink]="['app-dashboard', 'edit', part.name, item.id]">{{ item.title }}</a>
                    </ng-container>
                    <!-- archive -->
                    <ng-container *ngIf="item.status==='archive'">
                      <a href="javascript:void(0)" (click)="dataService.unarchiveItem(part, item)">{{ item.title }}</a>
                    </ng-container>
                    <!-- trash -->
                    <ng-container *ngIf="item.status==='trash'">
                      <a href="javascript:void(0)" (click)="dataService.restoreItem(part, item)">{{ item.title }}</a>
                    </ng-container>
                  </div>  
  
                  <ul class="actions">

                    <!-- draft / publish -->
                    <ng-container *ngIf="item.status==='draft' || item.status==='publish'">
                    <li class="edit">
                      <a [usefulRouterLink]="['app-dashboard', 'edit', part.name, item.id]">Edit</a>
                    </li>
                    <li class="copy">
                      <a
                        [usefulRouterLink]="['app-dashboard', 'copy', part.name, item.id]"
                        [usefulRouteExtras]="{queryParams: { type: type }}"
                      >Copy</a>
                    </li>
                    <li class="archive">
                      <a href="javascript:void(0)" (click)="dataService.archiveItem(part, item)">Archive</a>
                    </li>
                    <li class="trash">
                      <a href="javascript:void(0)" (click)="dataService.trashItem(part, item)">Trash</a>
                    </li>
                    <li class="preview">
                      <a href="javascript:void(0)" (click)="dataService.previewItem(part)">Preview</a>
                    </li>
                    </ng-container>

                    <!-- archive -->
                    <ng-container *ngIf="item.status==='archive'">
                    <li class="unarchive">
                      <a href="javascript:void(0)" (click)="dataService.unarchiveItem(part, item)">Unarchive</a>
                    </li>
                    </ng-container>

                    <!-- trash -->
                    <ng-container *ngIf="item.status==='trash'">
                    <li class="restore">
                      <a href="javascript:void(0)" (click)="dataService.restoreItem(part, item)">Restore</a>
                    </li>
                    </ng-container>

                    <li class="detail">
                      <a href="javascript:void(0)" (click)="detailId = detailId && detailId === item.id ? '' : item.id">Detail</a>
                    </li>

                  </ul>  
  
                  <ul class="mobile-detail" [class.show]="item.id===detailId">
                    <li class="author" *ngIf="item.authors | o1i; let author">
                      <span>Author</span>
                      <a href="#">{{ author.title }}</a>
                    </li>
                    <li class="comment" *ngIf="item.commentCount">
                      <span>Comment</span>
                      <em>{{ item.commentCount }}</em>
                    </li>
                    <li class="date">
                      <span>Date</span>
                      <em>{{ item.updatedAt === item.createdAt ? 'Published' : 'Modified' }} — {{ item.updatedAt | date }}</em>
                    </li>
                  </ul>

                </li>

                <ng-container *ngIf="!part.noI18n && localeCount > 1">

                  <ng-container *ngIf="!data.fullItemsByOrigin[listingItem.origin]; else missingTranslations;">
                    <li><a href="#" (click)="loadItemTranslations(listingItem);false;">View translations</a></li>
                  </ng-container>
                  
                  <ng-template #missingTranslations>
                    <li class="missing-item" *ngFor="let missingTranslation of (data.fullItemsByOrigin[listingItem.origin].missingTranslations || [])">
                      <div class="locale">{{ allLocales[missingTranslation].text }}</div>
                      <div class="major">
                        <a
                          [usefulRouterLink]="['app-dashboard', 'copy', part.name, listingItem.id]"
                          [usefulRouteExtras]="{queryParams: { type: type, locale: missingTranslation }}"
                        >Add the translation</a>
                      </div>
                    </li>
                  </ng-template>

                </ng-container>

              </ul>
            </td>

            <td class="author">  
              <ul>
                <li *ngFor="let item of items">              
                  <ng-container *ngIf="item.authors | o1i; let author">
                    <span>Author</span>
                    <a href="#">{{ author.title }}</a>
                  </ng-container>
                </li>
              </ul>  
            </td>

            <td class="comment">              
              <ul>
                <li *ngFor="let item of items">
                  <span>Comment</span>
                  <em>{{ item.commentCount || '—' }}</em>
                </li>
              </ul>  
            </td>

            <td class="date">
              <ul>
                <li *ngFor="let item of items">
                  <span>Date</span>
                  <em>{{ item.updatedAt === item.createdAt ? 'Published' : 'Modified' }} — {{ item.updatedAt | date }}</em>
                </li>
              </ul>  
            </td>
  
          </ng-container>
          </tr>
        </tbody>  
        <tfoot>
          <tr>
            <td colspan="42">
              <div class="tfoot">
                <div class="left">
                  <button class="button-outline-medium-sm" (click)="previousPage()" [disabled]="(query && data.searchItems) || pageNo === 1">
                    <i class="icon-medium-tint icon-dashboard-left"></i>
                  </button>
                  <button class="button-outline-medium-sm" (click)="nextPage()" [disabled]="(query && data.searchItems) || data.totalPages === 1 || pageNo === data.totalPages">
                    <i class="icon-medium-tint icon-dashboard-right"></i>
                  </button>
                </div>
                <div class="right">
                  {{ (query && data.searchItems) ? '-/-' : (pageNo + '/' + data.totalPages) }} pages
                </div>
              </div>
            </td>
          </tr>
        </tfoot>  
      </table>

      <div class="footbar">
        <ng-container *ngTemplateOutlet="listingBar"></ng-container>
      </div>

    </div>

  </ng-container>
  </ng-container>
  </div>

  <ng-template #notFound>
    <div class="not-found">Some thing wrong!</div>
  </ng-template>

</div>

<ng-template #loadingView>
  <div class="loading">
    <nguix-dashboard-spinner></nguix-dashboard-spinner>
  </div>
</ng-template>
